import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var LogSearch = /*#__PURE__*/function () {
  /**
   * @param {LogProvider} provider
   */
  function LogSearch(provider) {
    _classCallCheck(this, LogSearch);

    _defineProperty(this, "name", 'logreader-search');

    this.provider = provider;
    this.initialize();
  }

  _createClass(LogSearch, [{
    key: "initialize",
    value: function initialize() {
      OC.Plugins.register('OCA.Search.Core', this);
    }
  }, {
    key: "attach",
    value: function attach(search) {
      var _this = this;

      search.setFilter('settings', _.debounce(function (query) {
        if (query.length >= 3 || query == '') {
          _this.provider.query = query;
        }
      }, 250));
    }
  }]);

  return LogSearch;
}();